import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { change, Field, reduxForm } from 'redux-form';
import moment from 'moment';


import { CancelButton } from '../../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import { renderAutoCompleteSingleSelect, renderDateField, renderCheckBox } from '../../../../../../../../components/reduxFields';
import { getPatientSkillAcquisitionTargetSingleGraph } from '../actions/skillAquisitionTargetActions';
import PercentageStepsCorrectGraph from './percentageStepsCorrectGraph';
import StepPerformanceGraph from './stepPerformanceGraph';
import IndividualStepsGraph from './individualStepsGraph';
import TimeOfDayGraph from './timeOfDayGraph';

const TAGraphType = [
    { id: 1, value: "% Steps Correct" },
    { id: 2, value: "Step Performance" },
    { id: 3, value: "Individual Steps" },
    { id: 4, value: "Time of day" },
    { id: 5, value: "PEAK Score" }
]

class TAGraphModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      selectedGraphType: null,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      displayLegendCheckBox: true,
      disableLegend: true,
      hideGridlinesCheckBox: true,
      hideGridlines: false,
      displayAverageCheckBox: true,
      displayAverage: false,
      hidegraphByStaffCheckBox: true,
      graphByStaff: false,
      displaySavedPhaseChangeLines: false,
      displayPhaseChangeLineForBaseline: false,
      displayphaseChangeLineWhenTheGoalWasMastered: false,      
      phaseChangeLineDataFlag : true,
      phaseChangeBaselineDataFlag : true,
      phaseChangeMasteredlineDataFlag : true,
      displayPhaseChangeLinesCheckbox: true,
    };
    this.setPhaselineState = this.setPhaselineState.bind(this);
    this.setBaselineState = this.setBaselineState.bind(this);
    this.setMasteredlineState = this.setMasteredlineState.bind(this);
  }

  componentWillMount() {
    if(this.props.targetType.toUpperCase() === "TA") {
        this.setState({
            graphType: TAGraphType
        });
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  checkDisable = (event, Id) => {   
    if(Id === 'disableLegend')
    {
      this.setState({ disableLegend: !event.target.checked }, () => this.loadData());
    }
    else if(Id === 'hideGridlines')
    {
      this.setState({ hideGridlines: event.target.checked }, () => this.loadData());
    }
    else if(Id === 'displayAverage')
    {
      this.setState({ displayAverage: event.target.checked }, () => this.loadData());
    }
    else if(Id === 'graphByStaff')
    {
      this.setState({ graphByStaff: event.target.checked ? true : false }, () => this.loadData());      
    }
    else if(Id === 'displaySavedPhaseChangeLines')
    {
      this.setState({ displaySavedPhaseChangeLines: event.target.checked ? true : false,
        phaseChangeLineDataFlag : true,        
      });      
    }
    else if(Id === 'displayPhaseChangeLineForBaseline')
    {
      this.setState({ displayPhaseChangeLineForBaseline: event.target.checked ? true : false,
        phaseChangeBaselineDataFlag : true,        
      });      
    }
    else if(Id === 'displayphaseChangeLineWhenTheGoalWasMastered')
    {
      this.setState({ displayphaseChangeLineWhenTheGoalWasMastered: event.target.checked ? true : false,
        phaseChangeMasteredlineDataFlag : true,
      });      
    } 
  }

  loadData() {
    let FromDate = moment(this.state.FromDate).format('YYYY-MM-DD');
    let ToDate =  moment(this.state.ToDate).format('YYYY-MM-DD');
    if(this.state.selectedGraphType)
    {
      this.props.getPatientSkillAcquisitionTargetSingleGraph(this.props.patientId, 'TA', this.props.skillAquisitionTargetId, this.props.skillsAcquisitionProgramId, FromDate, ToDate, this.state.graphByStaff, this.state.selectedGraphType.toUpperCase());
    }
  }

  handleNewRequestGraphType = (input, selectedRecord) => { 
    input.onChange(selectedRecord.value);    

    this.setState({ 
      displaySavedPhaseChangeLines: false,
      displayPhaseChangeLineForBaseline: false,
      displayphaseChangeLineWhenTheGoalWasMastered: false,    
      phaseChangeLineDataFlag : true,
      phaseChangeBaselineDataFlag : true,
      phaseChangeMasteredlineDataFlag : true
    }, () => { 
      this.props.dispatch(change('TAGraphModalForm', `displaySavedPhaseChangeLines`, false));
      this.props.dispatch(change('TAGraphModalForm', `displayPhaseChangeLineForBaseline`, false));
      this.props.dispatch(change('TAGraphModalForm', `displayphaseChangeLineWhenTheGoalWasMastered`, false));
    });

    if(selectedRecord.label.toUpperCase() === "% STEPS CORRECT") {  
        this.setState({
            displayLegendCheckBox : true,
            hideGridlinesCheckBox: true,
            displayAverageCheckBox: true,
            hidegraphByStaffCheckBox: false,
            displayPhaseChangeLinesCheckbox: true,
            selectedGraphType: "PERCENTAGE STEPS CORRECT"
        }, () => this.loadData());  
    } else  if(selectedRecord.label.toUpperCase() === "STEP PERFORMANCE") {  
        this.setState({
            displayLegendCheckBox : false,
            hideGridlinesCheckBox: true,
            displayAverageCheckBox: false,
            hidegraphByStaffCheckBox: false,
            hidegraphByStaffCheckBox: true,
            displayPhaseChangeLinesCheckbox: false,
            selectedGraphType: selectedRecord.label.toUpperCase()
        }, () => this.loadData());
    } else  if(selectedRecord.label.toUpperCase() === "INDIVIDUAL STEPS") {   
        this.setState({
            displayLegendCheckBox : false,
            hideGridlinesCheckBox: true,
            displayAverageCheckBox: false,
            hidegraphByStaffCheckBox: true,
            displayPhaseChangeLinesCheckbox: false,
            selectedGraphType: selectedRecord.label.toUpperCase()
        }, () => this.loadData());
    } else  if(selectedRecord.label.toUpperCase() === "TIME OF DAY") {   
      this.setState({
          displayLegendCheckBox : false,
          hideGridlinesCheckBox: true,
          displayAverageCheckBox: false,
          hidegraphByStaffCheckBox: false,
          displayPhaseChangeLinesCheckbox: true,
          selectedGraphType: selectedRecord.label.toUpperCase()
      }, () => this.loadData());
  } else if(selectedRecord.label.toUpperCase() === "PEAK SCORE") {  
    this.setState({
        displayLegendCheckBox : true,
        hideGridlinesCheckBox: true,
        displayAverageCheckBox: true,
        hidegraphByStaffCheckBox: false,
        displayPhaseChangeLinesCheckbox: true,
        selectedGraphType: "PEAK SCORE"
    }, () => this.loadData());  
  }
  }

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value,
      displaySavedPhaseChangeLines: false,
      displayPhaseChangeLineForBaseline: false,
      displayphaseChangeLineWhenTheGoalWasMastered: false,    
      phaseChangeLineDataFlag : true,
      phaseChangeBaselineDataFlag : true,
      phaseChangeMasteredlineDataFlag : true
    }, () => { 
      this.props.dispatch(change('TAGraphModalForm', `displaySavedPhaseChangeLines`, false));
    this.props.dispatch(change('TAGraphModalForm', `displayPhaseChangeLineForBaseline`, false));
    this.props.dispatch(change('TAGraphModalForm', `displayphaseChangeLineWhenTheGoalWasMastered`, false));
      this.loadData();});
  }

  setPhaselineState(phaseChangeLineDataFlag) {          
    this.setState({
      phaseChangeLineDataFlag : phaseChangeLineDataFlag,      
    });
  }

  setBaselineState(phaseChangeBaselineDataFlag) {          
    this.setState({      
      phaseChangeBaselineDataFlag : phaseChangeBaselineDataFlag,      
    });
  }

  setMasteredlineState(phaseChangeMasteredlineDataFlag) {          
    this.setState({
      phaseChangeMasteredlineDataFlag : phaseChangeMasteredlineDataFlag
    });
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
      ];
    return <Dialog className="custom_modal_new_appointment" title={this.props.modalTitle} modal={false} open={this.state.open} actions={actions} autoScrollBodyContent={true}>
        {this.renderLoading()}
        <div className='row'>
            <div className="col-sm-3 mt-40">
                <Field
                    name='graphTypeId'
                    label="Graph Type"
                    options={this.state.graphType}
                    handleNewRequest={this.handleNewRequestGraphType}
                    component={renderAutoCompleteSingleSelect}
                />
            </div>
            <div className="col-sm-3 mt-10">
                <Field
                    name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    maxDate={this.state.ToDate}
                    component={renderDateField} />
            </div>
            <div className="col-sm-3 mt-10">
                <Field
                    name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate={this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
            </div>
            {this.state.displayLegendCheckBox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="disableLegend" 
                    label="Disable Legends"
                    onChange={(e) => this.checkDisable(e, 'disableLegend')}
                    component={renderCheckBox} />
            </div>}
            {this.state.hideGridlinesCheckBox && 
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="hideGridlines" 
                    label="Hide Gridlines"
                    onChange={(e) => this.checkDisable(e, 'hideGridlines')}
                    component={renderCheckBox} />
            </div>}
            {this.state.displayAverageCheckBox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displayAverage" 
                    label="Display Average"
                    onChange={(e) => this.checkDisable(e, 'displayAverage')}
                    component={renderCheckBox} />
            </div>}
            {!this.state.hidegraphByStaffCheckBox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="graphByStaff" 
                    label="View By Staff"
                    onChange={(e) => this.checkDisable(e, 'graphByStaff')}
                    component={renderCheckBox} />
            </div>}
            {this.state.displayPhaseChangeLinesCheckbox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displaySavedPhaseChangeLines" 
                    label="Display saved phase change lines"
                    onChange={(e) => this.checkDisable(e, 'displaySavedPhaseChangeLines')}
                    component={renderCheckBox} />
            </div>}
            {this.state.displayPhaseChangeLinesCheckbox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displayPhaseChangeLineForBaseline" 
                    label="Display baseline phase change line"
                    onChange={(e) => this.checkDisable(e, 'displayPhaseChangeLineForBaseline')}
                    component={renderCheckBox} />
            </div>}
            {this.state.displayPhaseChangeLinesCheckbox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displayphaseChangeLineWhenTheGoalWasMastered" 
                    label="Display mastered phase change line"
                    onChange={(e) => this.checkDisable(e, 'displayphaseChangeLineWhenTheGoalWasMastered')}
                    component={renderCheckBox} />
            </div>}
            </div>
            <div>            
            {
                (this.state.selectedGraphType !== null && (this.state.selectedGraphType === "PERCENTAGE STEPS CORRECT" || this.state.selectedGraphType === "PEAK SCORE")) && <PercentageStepsCorrectGraph graphTitle={this.props.modalTitle} disableLegend={this.state.disableLegend} hideGridlines={this.state.hideGridlines} displayAverage={this.state.displayAverage} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines}  displayPhaseChangeLineForBaseline = {this.state.displayPhaseChangeLineForBaseline}  displayphaseChangeLineWhenTheGoalWasMastered = {this.state.displayphaseChangeLineWhenTheGoalWasMastered} 
                phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag}  phaseChangeBaselineDataFlag = {this.state.phaseChangeBaselineDataFlag}  phaseChangeMasteredlineDataFlag = {this.state.phaseChangeMasteredlineDataFlag}  
                setPhaselineState={this.setPhaselineState} setBaselineState={this.setBaselineState} setMasteredlineState={this.setMasteredlineState} 
                xAxisName={this.state.selectedGraphType === "PEAK SCORE" ? 'PEAK Score %' : '% Steps Correct'}
                />
            }
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType === "STEP PERFORMANCE") && <StepPerformanceGraph graphTitle={this.props.modalTitle} hideGridlines={this.state.hideGridlines} />
            }
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType === "INDIVIDUAL STEPS") && <IndividualStepsGraph graphTitle={this.props.modalTitle} hideGridlines={this.state.hideGridlines} />
            }
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType === "TIME OF DAY") && <TimeOfDayGraph graphTitle={this.props.modalTitle} hideGridlines={this.state.hideGridlines} graphByStaff={this.state.graphByStaff} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines}  displayPhaseChangeLineForBaseline = {this.state.displayPhaseChangeLineForBaseline}  displayphaseChangeLineWhenTheGoalWasMastered = {this.state.displayphaseChangeLineWhenTheGoalWasMastered} 
                phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag}  phaseChangeBaselineDataFlag = {this.state.phaseChangeBaselineDataFlag}  phaseChangeMasteredlineDataFlag = {this.state.phaseChangeMasteredlineDataFlag}  
                setPhaselineState={this.setPhaselineState} setBaselineState={this.setBaselineState} setMasteredlineState={this.setMasteredlineState}
                />
            }
            
        </div>
      </Dialog>;
  }
}

TAGraphModal = reduxForm({
    form: 'TAGraphModalForm',
    enableReinitialize: true,
})(TAGraphModal);


export default connect(null,{getPatientSkillAcquisitionTargetSingleGraph})(TAGraphModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Target/TAGraphModal/index.js